var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/react/exit-break/ExitBreakPlugin.tsx
import { toPlatePlugin } from "@udecode/plate-common/react";

// src/lib/exit-break/BaseExitBreakPlugin.ts
import { createTSlatePlugin } from "@udecode/plate-common";
var BaseExitBreakPlugin = createTSlatePlugin({
  key: "exitBreak",
  options: {
    rules: [
      { hotkey: "mod+enter" },
      { before: true, hotkey: "mod+shift+enter" }
    ]
  }
});

// src/react/exit-break/onKeyDownExitBreak.ts
import { getBlockAbove, isHotkey, queryNode } from "@udecode/plate-common";

// src/lib/exit-break/transforms/exitBreak.ts
import {
  BaseParagraphPlugin,
  getPath,
  insertElements
} from "@udecode/plate-common";
import { Path } from "slate";

// src/lib/exit-break/queries/exitBreakAtEdges.ts
import {
  isExpanded,
  isSelectionAtBlockEnd,
  isSelectionAtBlockStart
} from "@udecode/plate-common";
var exitBreakAtEdges = (editor, {
  end,
  start
}) => {
  let queryEdge = false;
  let isEdge = false;
  let isStart = false;
  if (start || end) {
    queryEdge = true;
    if (start && isSelectionAtBlockStart(editor)) {
      isEdge = true;
      isStart = true;
    }
    if (end && isSelectionAtBlockEnd(editor)) {
      isEdge = true;
    }
    if (isEdge && isExpanded(editor.selection)) {
      editor.deleteFragment();
    }
  }
  return {
    isEdge,
    isStart,
    queryEdge
  };
};

// src/lib/exit-break/transforms/exitBreak.ts
var exitBreak = (editor, {
  before,
  defaultType = editor.getType(BaseParagraphPlugin),
  level = 0,
  query = {},
  relative = false
}) => {
  if (!editor.selection) return;
  const { isEdge, isStart, queryEdge } = exitBreakAtEdges(editor, query);
  if (isStart) before = true;
  if (queryEdge && !isEdge) return;
  const selectionPath = getPath(editor, editor.selection);
  const slicedPath = relative ? selectionPath.slice(0, -level) : selectionPath.slice(0, level + 1);
  const insertPath = before ? slicedPath : Path.next(slicedPath);
  insertElements(
    editor,
    editor.api.create.block({ children: [{ text: "" }], type: defaultType }),
    {
      at: insertPath,
      select: !isStart
    }
  );
  return true;
};

// src/react/exit-break/onKeyDownExitBreak.ts
var onKeyDownExitBreak = ({
  editor,
  event,
  getOptions
}) => {
  const { rules = [] } = getOptions();
  if (event.defaultPrevented) return;
  const entry = getBlockAbove(editor);
  if (!entry) return;
  rules.forEach((_a) => {
    var _b = _a, { hotkey } = _b, rule = __objRest(_b, ["hotkey"]);
    if (isHotkey(hotkey, event) && queryNode(entry, rule.query) && exitBreak(editor, rule)) {
      event.preventDefault();
      event.stopPropagation();
    }
  });
};

// src/react/exit-break/ExitBreakPlugin.tsx
var ExitBreakPlugin = toPlatePlugin(BaseExitBreakPlugin, {
  handlers: {
    onKeyDown: onKeyDownExitBreak
  }
});

// src/react/single-line/SingleLinePlugin.tsx
import { toPlatePlugin as toPlatePlugin2 } from "@udecode/plate-common/react";

// src/lib/single-line/BaseSingleLinePlugin.ts
import { createSlatePlugin } from "@udecode/plate-common";

// src/lib/single-line/withSingleLine.ts
import { removeNodes } from "@udecode/plate-common";
var withSingleLine = ({ editor }) => {
  const { normalizeNode } = editor;
  editor.insertBreak = () => null;
  editor.normalizeNode = (entry) => {
    if (entry[1].length === 0 && editor.children.length > 1) {
      removeNodes(editor, {
        at: [],
        match: (node, path) => path.length === 1 && path[0] > 0,
        mode: "highest"
      });
      return;
    }
    normalizeNode(entry);
  };
  return editor;
};

// src/lib/single-line/BaseSingleLinePlugin.ts
var BaseSingleLinePlugin = createSlatePlugin({
  key: "singleLine",
  extendEditor: withSingleLine
});

// src/react/single-line/onKeyDownSingleLine.ts
import { Hotkeys } from "@udecode/plate-common";
var onKeyDownSingleLine = ({ event }) => {
  if (event.defaultPrevented) return;
  if (Hotkeys.isSplitBlock(event)) {
    event.preventDefault();
  }
};

// src/react/single-line/SingleLinePlugin.tsx
var SingleLinePlugin = toPlatePlugin2(BaseSingleLinePlugin, {
  handlers: {
    onKeyDown: onKeyDownSingleLine
  }
});

// src/react/soft-break/SoftBreakPlugin.tsx
import { toPlatePlugin as toPlatePlugin3 } from "@udecode/plate-common/react";

// src/lib/soft-break/BaseSoftBreakPlugin.ts
import {
  createTSlatePlugin as createTSlatePlugin2
} from "@udecode/plate-common";
var BaseSoftBreakPlugin = createTSlatePlugin2({
  key: "softBreak",
  options: {
    rules: [{ hotkey: "shift+enter" }]
  }
});

// src/react/soft-break/onKeyDownSoftBreak.ts
import { getBlockAbove as getBlockAbove2, isHotkey as isHotkey2, queryNode as queryNode2 } from "@udecode/plate-common";
var onKeyDownSoftBreak = ({
  editor,
  event,
  getOptions
}) => {
  const { rules = [] } = getOptions();
  if (event.defaultPrevented) return;
  const entry = getBlockAbove2(editor);
  if (!entry) return;
  rules.forEach(({ hotkey, query }) => {
    if (isHotkey2(hotkey, event) && queryNode2(entry, query)) {
      event.preventDefault();
      event.stopPropagation();
      editor.insertText("\n");
    }
  });
};

// src/react/soft-break/SoftBreakPlugin.tsx
var SoftBreakPlugin = toPlatePlugin3(BaseSoftBreakPlugin, {
  handlers: {
    onKeyDown: onKeyDownSoftBreak
  }
});
export {
  ExitBreakPlugin,
  SingleLinePlugin,
  SoftBreakPlugin,
  onKeyDownExitBreak,
  onKeyDownSingleLine,
  onKeyDownSoftBreak
};
//# sourceMappingURL=index.mjs.map